import React from "react";
import { useLocation } from "react-router-dom";

interface NavBarItemProps {
  href: string;
  text: string;
}

export default function NavBarItem({ href, text }: NavBarItemProps) {
  const location = useLocation();
  const isActive = location.pathname === href;

  return (
    <li className="nav-item">
      <a className={`nav-link ${isActive && "active"}`} href={href}>{text}</a>
    </li>
  );
}
